export default __webpack_public_path__ + "static/media/astronauts.ea532e99.svg";